// ProductHuntBadge — our featured Product Hunt badge. One source of truth so the
// landing footer and the landing menu footer stay identical. The badge is an
// external SVG (the site CSP allows img-src https:); it opens Product Hunt in a
// new tab. Sized responsively (never wider than its column).
//
// HIDDEN FOR NOW (John, 2026-08-15) — one switch here parks it on every surface
// at once; flip it back and the footer and menu footer both light up again.
const SHOW_PRODUCT_HUNT = false;

export default function ProductHuntBadge({
  theme = "light",
  width = 220,
  className,
}: {
  theme?: "light" | "dark" | "neutral";
  width?: number;
  className?: string;
}) {
  if (!SHOW_PRODUCT_HUNT) return null;
  return (
    <a
      href="https://www.producthunt.com/products/innernet-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-innernet-2"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="innernet on Product Hunt"
      style={{ display: "inline-flex", lineHeight: 0 }}
    >
      {/* external badge — next/image can't proxy Product Hunt's live SVG */}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1185736&theme=${theme}`}
        alt="innernet - the internet, but yours. | Product Hunt"
        width={width}
        height={Math.round((width * 54) / 250)}
        style={{ width, maxWidth: "100%", height: "auto" }}
      />
    </a>
  );
}
